import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleSection />
        <TrustSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}